export default __webpack_public_path__ + "static/media/2-7t.144265d2.png";